import { generateApiClient } from '@guiker/rest-client'

import { AdminApi, AuthApi, PublicApi } from '../api-definition'
import { config } from '../config'

export const AdminApiClient = generateApiClient(config.apiName, AdminApi.routes)
export const AuthApiClient = generateApiClient(config.apiName, AuthApi.routes)
export const PublicApiClient = generateApiClient(config.apiName, PublicApi.routes)
